import { SearchBar } from '../SearchAndFilters/SearchBar'
import TableHeader from './TableHeader/TableHeader'
import useStyles from './useStyles'
import TableItem from './TableItem/TableItem'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import { Filters } from '../SearchAndFilters/Filters/Filters'
import { getInternalRecycle } from '../../../../redux/actions/Storage'

function TableNavigable ({ id, rows, setRows, setLoading }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [valueFilter, setvalueFilter] = useState(null)
  const [dateValue, setdateValue] = useState(null)
  const [allChecked, setAllChecked] = useState(false)
  const [elementsChecked, setElementsChecked] = useState([])
  const [openReset, setOpenReset] = useState(null)
  const [routeValue, setRouteValue] = useState(null)

  // params default for request getAllrecycleBin
  const [params, setParams] = useState({
    // cliente
    // subgroupId: suborganizationID
    // estudio
    groupId: id
  })

  // request get recycle by params
  const getRecycleRequest = async (param = params) => {
    setLoading(true)
    setAllChecked(false)
    const response = await dispatch(getInternalRecycle(param))
    setRows(response)
    setLoading(false)
  }

  // request get ALL recycle
  const handleGetAllRecycle = async () => {
    await getRecycleRequest({
      groupId: id
    })
  }

  // first render - request get ALL default
  useEffect(async () => {
    setLoading(true)
    await handleGetAllRecycle()
    setLoading(false)
  }, [id])

  // ----------------------------------------------------------------------------------
  // FILTERS FUNCTIONS

  // change params for new request filter
  const handleGetFilterRecycle = async (typeFilter = null, value = null) => {
    switch (typeFilter) {
      case 'search_value':
        setParams({ ...params, documentName: value })
        break
      case 'search_date':
        setParams({ ...params, start: value.startDate, end: value.endDate })
        break
      case 'search_route':
        setParams({ ...params, path: value })
        setRouteValue(true)
    }
  }

  // reset valueFilter (name search) and new request
  const resetFilterName = async () => {
    setLoading(true)
    const parametros = {
      groupId: id
    }
    if (dateValue) {
      // si hay fecha indicada agregar
      parametros.start = dateValue.startDate
      parametros.end = dateValue.endDate
    }
    // si hay ruta agregar
    await getRecycleRequest(parametros)
    setParams(parametros)
    setLoading(false)
  }

  // reset dateValue (date search) and new request
  const resetFilterDate = async () => {
    setLoading(true)
    const parametros = {
      groupId: id
    }
    if (valueFilter) {
      // si hay name indicada agregar
      parametros.documentName = valueFilter
    }
    // si hay ruta agregar
    await getRecycleRequest(parametros)
    setParams(parametros)
    setLoading(false)
  }

  const resetFilterRoute = async () => {
    setLoading(true)
    const parametros = {
      groupId: id
    }
    if (routeValue) {
      parametros.path = valueFilter
    }
    await getRecycleRequest(parametros)
    setParams(parametros)
    setLoading(false)
  }

  // get new request if change params
  useEffect(async () => {
    setLoading(true)
    setOpenReset(true)
    if (params.documentName || params.path || params.start) {
      await getRecycleRequest()
    }
    setLoading(false)
  }, [params])

  // update allCheck by elementsChecked changes
  useEffect(() => {
    if (elementsChecked.length === 0 && allChecked) {
      setAllChecked(false)
    }
    if (
      elementsChecked.length > 0 &&
      elementsChecked.length === rows.length &&
      !allChecked
    ) {
      setAllChecked(true)
    }
  }, [elementsChecked])

  return (
    <div className={classes.root}>
      <Filters
        valueFilter={valueFilter}
        setvalueFilter={setvalueFilter}
        dateValue={dateValue}
        setdateValue={setdateValue}
        handleGetFilterRecycle={handleGetFilterRecycle}
        resetFilterName={resetFilterName}
        resetFilterDate={resetFilterDate}
        handleGetAllRecycle={handleGetAllRecycle}
        openReset={openReset}
        setOpenReset={setOpenReset}
        routeValue={routeValue}
        setRouteValue={setRouteValue}
        resetFilterRoute={resetFilterRoute}
      />
      <SearchBar
        setLoading={setLoading}
        setvalueFilter={setvalueFilter}
        handleGetFilterRecycle={handleGetFilterRecycle}
        elementsChecked={elementsChecked}
        getRecycleRequest={getRecycleRequest}
      />
      <div className={classes.tableWrap}>
        <table className={classes.table}>
          <TableHeader
            allChecked={allChecked}
            setAllChecked={setAllChecked}
            setElementsChecked={setElementsChecked}
          />
          <tbody className={classes.tableBody}>
            {rows &&
              rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.documentId}
                  item={item}
                  setLoading={setLoading}
                  allChecked={allChecked}
                  setAllChecked={setAllChecked}
                  elementsChecked={elementsChecked}
                  setElementsChecked={setElementsChecked}
                  getRecycleRequest={getRecycleRequest}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TableNavigable
